module.exports = __webpack_public_path__ + "img/build1060.4c000d01.png";